import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCreativePerformanceAdAccountSwitched.meta';

export const useTrackCreativePerformanceAdAccountSwitched = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreativePerformanceAdAccountSwitched = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackCreativePerformanceAdAccountSwitched };
};
